// constants
const SET_LOADING_FOR_SYNC_ERP_STUDENTS = "SET_LOADING_FOR_SYNC_ERP_STUDENTS";

// actions
export const setLoadingForSyncErpStudents = (payload) => ({
  type: SET_LOADING_FOR_SYNC_ERP_STUDENTS,
  payload,
});

// reducer
const initialState = {
  loadingForSyncErpStudents: false
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING_FOR_SYNC_ERP_STUDENTS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
